// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressItem_container__3qX0P","button":"AddressItem_button__3r4jn"};